export default __webpack_public_path__ + "static/media/210912 pumpkin.a0e53284.png";